import { render, staticRenderFns } from "./addNotice.vue?vue&type=template&id=b849bb40&scoped=true"
import script from "./addNotice.vue?vue&type=script&lang=js"
export * from "./addNotice.vue?vue&type=script&lang=js"
import style0 from "./addNotice.vue?vue&type=style&index=0&id=b849bb40&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b849bb40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b849bb40')) {
      api.createRecord('b849bb40', component.options)
    } else {
      api.reload('b849bb40', component.options)
    }
    module.hot.accept("./addNotice.vue?vue&type=template&id=b849bb40&scoped=true", function () {
      api.rerender('b849bb40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/notice/components/addNotice.vue"
export default component.exports